import React, { useEffect, createElement } from 'react';
const TITLE = 'The Ultimate Auction Secrets Blueprint 2026 | Buy Homes Below Market';
const DESCRIPTION = 'The 2026 Home Auction Ultimate Guide. Buy your first home for a fraction of retail price without a 20% downpayment. Instant PDF download — just $6.36.';
const OG_IMAGE = 'https://cdn.magicpatterns.com/uploads/sQegeoMXyPqBZuUVKycqxU/heylloyd-image-1779611485942.png';
function setMeta(attr: 'name' | 'property', key: string, content: string) {
  if (typeof document === 'undefined') return;
  let el = document.head.querySelector(`meta[${attr}="${key}"]`) as HTMLMetaElement | null;
  if (!el) {
    el = document.createElement('meta');
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute('content', content);
}
export function SEO() {
  useEffect(() => {
    if (typeof document === 'undefined') return;
    // Page title (browser tab + SERP)
    document.title = TITLE;
    // Standard SEO meta tags
    setMeta('name', 'title', TITLE);
    setMeta('name', 'description', DESCRIPTION);
    setMeta('name', 'keywords', 'home auctions, foreclosure auctions, tax deed properties, real estate auction guide, buy home below market, FHA loophole, first time home buyer 2026, auction protocol');
    // Open Graph (Facebook, LinkedIn, Pinterest)
    setMeta('property', 'og:title', TITLE);
    setMeta('property', 'og:description', DESCRIPTION);
    setMeta('property', 'og:type', 'product');
    setMeta('property', 'og:image', OG_IMAGE);
    setMeta('property', 'og:site_name', 'The Auction Protocol');
    // Twitter Card
    setMeta('name', 'twitter:card', 'summary_large_image');
    setMeta('name', 'twitter:title', TITLE);
    setMeta('name', 'twitter:description', DESCRIPTION);
    setMeta('name', 'twitter:image', OG_IMAGE);
  }, []);
  return null;
}